// Define the possible component actions for the reducer to call.
export const ACTIONS = {
  SET_STATUS: "setStatus",
  SET_QUESTIONS: "setQuestions",
  SET_LCP: "setLCP",
  SET_MARKET: "setMarket",
  SET_CONTRACTOR: "setContractor",
  SET_IN_HOUSE_SPLICER: "setInHouseSplicer",
  SET_CREW: "setCrew",
  SET_FIBER_SPLICING: "setFiberSplicing",
  SET_HOUSEKEEPING: "setHousekeeping",
  SET_REQUIRED_PPE: "setRequiredPPE",
  SET_REQUIRED_WAP: "setRequiredWAP",
  SET_PREVIEW: "setPreview",
  LOADING_TOGGLE: "loadingToggle",
  SET_SUBMISSION_STATUS: "setSubmissionStatus",
  SET_FORM_VALID: "setFormValid",
  TOOL_INVENTORY_TOGGLE: "toolInventoryToggle",

  // Tool Inventory
  SET_VEHICLE_NUMBER: "setVehicleNumber",
  SET_VEHICLE_TYPE: "setVehicleType",
  SET_TRAILER_TYPE_AND_NUM: "setTrailerTypeAndNum",
  SET_OTDR_MAKE_MODEL: "setOTDRMakeModel",
  SET_OTDR_SERIAL: "setOTDRSerial",
  SET_FS_MACHINE_SINGLE_MAKE_MODEL: "setFSMachineSingleMakeModel",
  SET_FS_MACHINE_SINGLE_SERIAL: "setFSMachineSingleSerial",
  SET_FS_MACHINE_RIBBON_SERIAL: "setFSMachineRibbonSerial",
  SET_FS_MACHINE_RIBBON_MAKE_MODEL: "setFSMachineRibbonMakeModel",
  SET_FIBER_MAKE_MODEL: "setFiberMakeModel",
  SET_FIBER_SERIAL: "setFiberSerial",
  SET_OPTICAL_LOSS_MAKE_MODEL_1: "setOpticalLossMakeModel1",
  SET_OPTICAL_LOSS_SERIAL_1: "setOpticalLossSerial1",
  SET_OPTICAL_LOSS_MAKE_MODEL_2: "setOpticalLossMakeModel2",
  SET_OPTICAL_LOSS_SERIAL_2: "setOpticalLossSerial2",
  SET_DRILL: "setDrill",
  SET_SPLICING_TABLE_MAKE_MODEL: "setSplicingTableMakeModel",
  SET_BUFFER_TUBE_MAKE_MODEL: "setBufferTubeMakeModel",
  SET_SPLICER_TENT_MAKE_MODEL: "setSplicerTentMakeModel",
  SET_FO_DROP_SLITTER_MAKE_MODEL: "setFODropSlitterMakeModel",
  SET_MIDSPAN_SPLITTER_MAKE_MODEL: "setMidspanSplitterMakeModel",
  SET_CORE_TUBE_ENTRY_KIT_MAKE_MODEL: "setCoreTubeEntryKitMakeModel",
  SET_TOOLSET_MAKE_MODEL: "setToolsetMakeModel",
  SET_SIGN_AND_HOLDER_MAKE_MODEL: "setSignAndHolderMakeModel",
  SET_CONES_MAKE_MODEL: "setConesMakeModel",
  SET_SAFETY_VEST_AND_HARD_HAT_MAKE_MODEL: "setSafetyVestAndHardHatMakeModel",
  SET_HARNESS_MAKE_MODEL: "setHarnessMakeModel",
  SET_FISHTAPE_MAKE_MODEL: "setFishtapeMakeModel",
  SET_LADDER_28FT_MAKE_MODEL: "setLadder28ftMakeModel",
  SET_LADDER_6FT_MAKE_MODEL: "setLadder6ftMakeModel",
  SET_BARE_FIBER_ADAPTER_MAKE_MODEL: "setBareFiberAdapterMakeModel",
  SET_EXFO_LAUNCH_BAG_MAKE_MODEL: "setEXFOLaunchBagMakeModel",
  SET_HAND_TOOLS_MAKE_MODEL: "setHandToolsMakeModel",
  SET_TOOL_NOTES: "setToolNotes",
};

// Define the state's initial values.
export const initialState = {
  questions: null,
  status: "",
  loading: false,
  submissionStatus: "",
  selectedMarket: { value: "", label: "Select Market" },
  selectedLCP: { value: "", label: "Select LCP" },
  selectedContractor: { value: "", label: "Select Contractor" },
  selectedInHouseSplicer: { value: "", label: "Select In-House Splicer" },
  selectedCrew: { value: "", label: "Select Crew" },
  formValid: false,
  fiberSplicing: { textInput: "", valid: false, value: "" },
  housekeeping: { textInput: "", valid: false, value: "" },
  requiredPPE: { photos: null, textInput: "", valid: false, value: "" },
  requiredWAP: { textInput: "", valid: false, value: "" },
  preview: null,
  showToolInventory: false,

  // Tool Inventory
  bareFiberAdapterMakeModel: "CESI Bare Fiber Adapter",
  bufferTubeMakeModel: "Ideal 1 Small and 1 Large",
  conesMakeModel: "Metronet Supply Safety Cones",
  coreTubeEntryKitMakeModel: "Corning Core Tube Entry Tool",
  drill: "Milwaukee Drill M18 Fuel 2 Kit Hammer/Impact",
  exfoLaunchBagMakeModel: "EXFO Launch Bag",
  fiberMakeModel: "Noyes OFI 400",
  fiberSerial: "",
  fishTapeMakeModel: "Metronet Supply 200ft Fish Tape",
  foDropSlitterMakeModel: "Jonard Drop Slitter",
  fsMachineRibbonMakeModel: "",
  fsMachineRibbonSerial: "",
  fsMachineSingleMakeModel: "",
  fsMachineSingleSerial: "",
  handToolsMakeModel: "Metronet Supply Assorted Hand Tools",
  harnessMakeModel: "Metronet Supply Harness",
  ladder28ftMakeModel: "Louisville 28ft Fiberglass Extension Ladder",
  ladder6ftMakeModel: "Louisville 6ft Ladder",
  midspanSplitterMakeModel: "Jonard Mid-span Splitter Tool",
  opticalLossMakeModel1: "Noyes OLS7",
  opticalLossMakeModel2: "Noyes OPM5",
  opticalLossSerial1: "",
  opticalLossSerial2: "",
  otdrMakeModel: "",
  otdrSerial: "",
  safetyVestAndHardHatMakeModel: "Metronet Supply Safety Vest and Hard Hat",
  signAndHolderMakeModel: "2 Bone Sign Holders and 2 Men Working Signs",
  splicerTentMakeModel: "Pelsue 6506a Splicer Tent",
  splicingTableMakeModel: "U-Teck Fiber Optic Workstation",
  toolNotes: "",
  toolsetMakeModel: "Kobalt 227 Piece Toolset",
  trailerTypeAndNum: "",
  vehicleNumber: "",
  vehicleType: "",
};

const toolInputValid = (state) => {
  return (
    state.bareFiberAdapterMakeModel &&
    state.bufferTubeMakeModel &&
    state.conesMakeModel &&
    state.coreTubeEntryKitMakeModel &&
    state.drill &&
    state.exfoLaunchBagMakeModel &&
    state.fiberMakeModel &&
    state.fiberSerial &&
    state.fishTapeMakeModel &&
    state.foDropSlitterMakeModel &&
    state.fsMachineRibbonMakeModel &&
    state.fsMachineRibbonSerial &&
    state.fsMachineSingleMakeModel &&
    state.fsMachineSingleSerial &&
    state.handToolsMakeModel &&
    state.harnessMakeModel &&
    state.ladder28ftMakeModel &&
    state.ladder6ftMakeModel &&
    state.midspanSplitterMakeModel &&
    state.opticalLossMakeModel1 &&
    state.opticalLossMakeModel2 &&
    state.opticalLossSerial1 &&
    state.opticalLossSerial2 &&
    state.otdrMakeModel &&
    state.otdrSerial &&
    state.safetyVestAndHardHatMakeModel &&
    state.signAndHolderMakeModel &&
    state.splicerTentMakeModel &&
    state.splicingTableMakeModel &&
    state.toolsetMakeModel &&
    state.trailerTypeAndNum &&
    state.vehicleNumber &&
    state.vehicleType
  );
};

const checkFormValid = (state) => {
  return (
    state.fiberSplicing.valid === true &&
    state.housekeeping.valid === true &&
    state.requiredPPE.valid === true &&
    state.requiredWAP.valid === true &&
    ((state.showToolInventory === true && toolInputValid(state)) ||
      state.showToolInventory === false)
  );
};

// Define the component's reducer with an action switch and state handling.
export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_QUESTIONS:
      return {
        ...state,
        questions: action.value,
      };
    case ACTIONS.LOADING_TOGGLE:
      return {
        ...state,
        loading: state.loading ? false : true,
      };
    case ACTIONS.SET_STATUS:
      return {
        ...state,
        status: action.value,
        loading: false,
      };
    case ACTIONS.SET_SUBMISSION_STATUS:
      return {
        ...state,
        loading: false,
        submissionStatus: action.value,
      };
    case ACTIONS.SET_LCP:
      return {
        ...state,
        selectedLCP: action.value,
      };
    case ACTIONS.SET_MARKET:
      return {
        ...state,
        selectedMarket: action.value,
      };
    case ACTIONS.SET_CONTRACTOR:
      return {
        ...state,
        selectedContractor: action.value,
        selectedCrew: initialState.selectedCrew,
        selectedInHouseSplicer: initialState.selectedInHouseSplicer,
      };
    case ACTIONS.SET_IN_HOUSE_SPLICER:
      return {
        ...state,
        selectedInHouseSplicer: action.value,
        selectedContractor: initialState.selectedContractor,
        selectedCrew: initialState.selectedCrew,
      };
    case ACTIONS.SET_CREW:
      return {
        ...state,
        selectedCrew: action.value,
        selectedInHouseSplicer: initialState.selectedInHouseSplicer,
      };
    case ACTIONS.SET_FIBER_SPLICING:
      return {
        ...state,
        fiberSplicing: action.value,
      };
    case ACTIONS.SET_HOUSEKEEPING:
      return {
        ...state,
        housekeeping: action.value,
      };
    case ACTIONS.SET_REQUIRED_PPE:
      return {
        ...state,
        requiredPPE: action.value,
      };
    case ACTIONS.SET_REQUIRED_WAP:
      return {
        ...state,
        requiredWAP: action.value,
      };
    case ACTIONS.SET_PREVIEW:
      return {
        ...state,
        preview: action.value,
      };
    case ACTIONS.SET_FORM_VALID:
      return {
        ...state,
        formValid: checkFormValid(state),
      };
    case ACTIONS.TOOL_INVENTORY_TOGGLE:
      return {
        ...state,
        showToolInventory: state.showToolInventory === true ? false : true,
      };

    // Tool Inventory
    case ACTIONS.SET_VEHICLE_NUMBER:
      return {
        ...state,
        vehicleNumber: action.value,
      };
    case ACTIONS.SET_VEHICLE_TYPE:
      return {
        ...state,
        vehicleType: action.value,
      };
    case ACTIONS.SET_TRAILER_TYPE_AND_NUM:
      return {
        ...state,
        trailerTypeAndNum: action.value,
      };
    case ACTIONS.SET_OTDR_MAKE_MODEL:
      return {
        ...state,
        otdrMakeModel: action.value,
      };
    case ACTIONS.SET_OTDR_SERIAL:
      return {
        ...state,
        otdrSerial: action.value,
      };
    case ACTIONS.SET_FS_MACHINE_SINGLE_MAKE_MODEL:
      return {
        ...state,
        fsMachineSingleMakeModel: action.value,
      };
    case ACTIONS.SET_FS_MACHINE_SINGLE_SERIAL:
      return {
        ...state,
        fsMachineSingleSerial: action.value,
      };
    case ACTIONS.SET_FS_MACHINE_RIBBON_SERIAL:
      return {
        ...state,
        fsMachineRibbonSerial: action.value,
      };
    case ACTIONS.SET_FS_MACHINE_RIBBON_MAKE_MODEL:
      return {
        ...state,
        fsMachineRibbonMakeModel: action.value,
      };
    case ACTIONS.SET_FIBER_MAKE_MODEL:
      return {
        ...state,
        fiberMakeModel: action.value,
      };
    case ACTIONS.SET_FIBER_SERIAL:
      return {
        ...state,
        fiberSerial: action.value,
      };
    case ACTIONS.SET_OPTICAL_LOSS_MAKE_MODEL_1:
      return {
        ...state,
        opticalLossMakeModel1: action.value,
      };
    case ACTIONS.SET_OPTICAL_LOSS_SERIAL_1:
      return {
        ...state,
        opticalLossSerial1: action.value,
      };
    case ACTIONS.SET_OPTICAL_LOSS_MAKE_MODEL_2:
      return {
        ...state,
        opticalLossMakeModel2: action.value,
      };
    case ACTIONS.SET_OPTICAL_LOSS_SERIAL_2:
      return {
        ...state,
        opticalLossSerial2: action.value,
      };
    case ACTIONS.SET_DRILL:
      return {
        ...state,
        drill: action.value,
      };
    case ACTIONS.SET_SPLICING_TABLE_MAKE_MODEL:
      return {
        ...state,
        splicingTableMakeModel: action.value,
      };
    case ACTIONS.SET_BUFFER_TUBE_MAKE_MODEL:
      return {
        ...state,
        bufferTubeMakeModel: action.value,
      };
    case ACTIONS.SET_SPLICER_TENT_MAKE_MODEL:
      return {
        ...state,
        splicerTentMakeModel: action.value,
      };
    case ACTIONS.SET_FO_DROP_SLITTER_MAKE_MODEL:
      return {
        ...state,
        foDropSlitterMakeModel: action.value,
      };
    case ACTIONS.SET_MIDSPAN_SPLITTER_MAKE_MODEL:
      return {
        ...state,
        midspanSplitterMakeModel: action.value,
      };
    case ACTIONS.SET_CORE_TUBE_ENTRY_KIT_MAKE_MODEL:
      return {
        ...state,
        coreTubeEntryKitMakeModel: action.value,
      };
    case ACTIONS.SET_TOOLSET_MAKE_MODEL:
      return {
        ...state,
        toolsetMakeModel: action.value,
      };
    case ACTIONS.SET_SIGN_AND_HOLDER_MAKE_MODEL:
      return {
        ...state,
        signAndHolderMakeModel: action.value,
      };
    case ACTIONS.SET_CONES_MAKE_MODEL:
      return {
        ...state,
        conesMakeModel: action.value,
      };
    case ACTIONS.SET_SAFETY_VEST_AND_HARD_HAT_MAKE_MODEL:
      return {
        ...state,
        safetyVestAndHardHatMakeModel: action.value,
      };
    case ACTIONS.SET_HARNESS_MAKE_MODEL:
      return {
        ...state,
        harnessMakeModel: action.value,
      };
    case ACTIONS.SET_FISHTAPE_MAKE_MODEL:
      return {
        ...state,
        fishTapeMakeModel: action.value,
      };
    case ACTIONS.SET_LADDER_28FT_MAKE_MODEL:
      return {
        ...state,
        ladder28ftMakeModel: action.value,
      };
    case ACTIONS.SET_LADDER_6FT_MAKE_MODEL:
      return {
        ...state,
        ladder6ftMakeModel: action.value,
      };
    case ACTIONS.SET_BARE_FIBER_ADAPTER_MAKE_MODEL:
      return {
        ...state,
        bareFiberAdapterMakeModel: action.value,
      };
    case ACTIONS.SET_EXFO_LAUNCH_BAG_MAKE_MODEL:
      return {
        ...state,
        exfoLaunchBagMakeModel: action.value,
      };
    case ACTIONS.SET_HAND_TOOLS_MAKE_MODEL:
      return {
        ...state,
        handToolsMakeModel: action.value,
      };
    case ACTIONS.SET_TOOL_NOTES:
      return {
        ...state,
        toolNotes: action.value,
      };
    default:
      return state;
  }
};
